import { IconNote } from '@tabler/icons-react'

export const PERMISSION_SETS_NOTES_INCIDENTS = {
  id: 'Notes / Incidents',
  description:
    'Grant access to view, create, edit, and delete call notes and incidents.',
  icon: IconNote,
  sections: [
    {
      title: 'permissions',
      permissions: [
        {
          type: 'checkbox',
          label: 'View, create, edit, and delete notes and incidents',
        },
        {
          type: 'checkbox',
          label: `View others' notes and incidents`,
        },
        {
          type: 'checkbox',
          label: `Delete others' notes and incidents`,
        },
      ],
    },
  ],
}
